import React, { Component } from "react";
import ReactDOM from 'react-dom';
import { LangContext } from "../LangContext.jsx";
class FileItem extends Component {
  static contextType = LangContext;

  getFileImage = () => {
    const { filename, fileId } = this.props;
    let extension_file = filename.split('.').pop();
    let type = ['jpg', 'jpeg', 'png', 'gif'].includes(extension_file.toLowerCase()) ? 'image' : 'iframe';
    $.magnificPopup.open({ items: { src: '/files/provider/' + fileId }, type });
  };

  getFileDossier = () => {
    const { filename, personDocumentId } = this.props;
    let extension_file = filename.split('.').pop();
    let type = ['jpg', 'jpeg', 'png', 'gif'].includes(extension_file.toLowerCase()) ? 'image' : 'iframe';
    $.magnificPopup.open({ items: { src: '/files/' + personDocumentId }, type });
  };

  deleteFile = async () => {
    const { fileId } = this.props;
    window.blockUI();
    await axios
      .delete('/providers/file/delete/' + fileId, { headers: { 'content-type': 'application/json' } })
      .then(() => {
        window.unblockUI();
        KTUtil.btnRelease(KTUtil.getById('btnDelete'));
        swal
          .fire({
            text: 'Se ha eliminado el archivo',
            icon: 'success',
            buttonsStyling: false,
            confirmButtonText: 'Aceptar',
            customClass: { confirmButton: 'btn font-weight-bold btn-light-primary' },
            timer: 3000,
          })
          .then(function () {
            window.location.href = '/files?tab=locales';
          });
      })
      .catch((error) => {
        window.unblockUI();
        const message = getErrorsMessage(error);
        KTUtil.btnRelease(KTUtil.getById('btnDelete'));
        swal.fire({
          text: message,
          icon: 'error',
          buttonsStyling: false,
          confirmButtonText: 'Aceptar',
          customClass: { confirmButton: 'btn font-weight-bold btn-light-primary' },
        });
      });
  };

  handleDelete = () => {
    swal
      .fire({
        text: '¿Desea continuar con el borrado?',
        showCancelButton: true,
        icon: 'error',
        buttonsStyling: false,
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Cancelar',
        customClass: { confirmButton: 'btn font-weight-bold btn-light-primary', cancelButton: 'btn font-weight-bold btn-danger' },
      })
      .then((result) => {
        if (result.isConfirmed) {
          this.deleteFile();
        }
      });
  };

  render() {
    const { description, fileId, personDocumentId, filename, fileextension, frequency, created_at, dossier, dossier_type, activeTab } = this.props;
    return (
      <tr>
        <td>
          <img src={'/assets/img/' + window.getMimeSVG(fileextension != undefined && fileextension.length > 0 ? fileextension : filename)} />
        </td>
        <td>
          <div className="font-weight-bold">{description}</div>
        </td>
        {activeTab == 'files' && (
          <td>
            <div className="font-weight-bold">{dossier}</div>
            <div className="text-dark-50">{dossier_type}</div>
          </td>
        )}
        {activeTab == 'files' && (
          <td>
            <div className="font-weight-bold">{frequency == 'once' ? 'Único' : 'Recurrente'}</div>
          </td>
        )}
        <td>{created_at}</td>
        {activeTab == 'files' && (
          <td className="text-right">
            <a href={'files/' + personDocumentId} download target="_blank" className="btn btn-xs btn-icon btn-light-secondary mr-4">
              <i className="flaticon2-download text-primary"></i>
            </a>
            <a data-toggle="modal" onClick={this.getFileDossier} data-target={'#modal' + fileId} className="btn btn-xs btn-icon btn-light-secondary mr-4">
              <i className="flaticon2-right-arrow text-primary icon-sm"></i>
            </a>
          </td>
        )}
        {activeTab == 'locals' && (
          <td className="text-right">
            <a href={'/my_dossiers/file/edit/' + fileId} className="btn btn-xs btn-icon btn-light-secondary mr-4">
              <i className="flaticon2-edit text-primary"></i>
            </a>
            <button className="btn btn-xs btn-icon btn-light-secondary mr-4" onClick={this.handleDelete}>
              <i className="flaticon-delete fw-normal text-primary"></i>
            </button>
            <a href={'/my_dossiers/file/download/' + fileId} className="btn btn-xs btn-icon btn-light-secondary mr-4">
              <i className="flaticon2-download text-primary"></i>
            </a>
            <a data-toggle="modal" onClick={this.getFileImage} data-target={'#modal' + fileId} className="btn btn-xs btn-icon btn-light-secondary mr-4">
              <i className="flaticon2-right-arrow text-primary icon-sm"></i>
            </a>
          </td>
        )}
      </tr>
    );
  }
}

export default FileItem;

if (document.getElementById('FileItem')) {
  ReactDOM.render(<FileItem />, document.getElementById('FileItem'));
}
